/** Map the mailbox-connect OAuth `reason` to a GENERIC German message — the raw reason
 *  is used ONLY to branch, never rendered. Shared by the two screens that receive the
 *  OAuth return: Kommunikation, and Postfächer while Kommunikation is switched off. */
export function messageForErrorReason(reason: string | null): string {
  switch (reason) {
    case 'access_denied':
      return 'Die Verbindung wurde abgebrochen.';
    case 'not_whitelisted':
      return 'Dieses Google-Konto ist noch nicht freigeschaltet. Bitte fordere zuerst den Zugang an.';
    default:
      return 'Die Verbindung konnte nicht hergestellt werden. Bitte versuche es erneut.';
  }
}
